<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';
import type { MindShareResetModalProps } from '@/stores/modal';
interface Emits {
  (e: 'confirm'): void;
}

const props = defineProps<MindShareResetModalProps>();
const emit = defineEmits<Emits>();

const isSubmitting = ref(false);

const handleConfirm = () => {
  if (!props.memId) return;
  isSubmitting.value = true;
  props.onConfirm(props.memId);

  // 약간의 지연 후 로딩 상태 해제
  setTimeout(() => {
    isSubmitting.value = false;
  }, 300);
};
</script>

<template>
  <NoInputConfirmModal
    title="전체 나누기 리셋"
    message="전체나누기를 리셋하시겠습니까?<br>삭제된 나누기는 복구할 수 없습니다."
    modal-type="mind-share-reset"
    confirm-text="리셋하기"
    cancel-text="취소"
    @confirm="handleConfirm"
    :is-loading="isSubmitting"
  />
</template>
